import {
  AchReceiveACHTransferRequest,
  AchReceiveACHTransferResponse,
  AchSettleACHTransferRequest,
  AchSettleACHTransferResponse,
  RealtimeTransfer,
  WireReceiveWireTransferRequest,
  WireReceiveWireTransferResponse,
  WireSettleWireTransferRequest,
  WireSettleWireTransferResponse,
} from '~/typings/API';
import { convertValues } from '~/util';

import { CardProgram } from './CardProgramRepository';
import { client } from './client';

interface RealtimeReceiveTransferRequest extends WireReceiveWireTransferRequest {}

export interface CreateCardProgramRequest {
  description?: string;
  type: 'credit' | 'charge' | 'debit';
}

export class SimulateRepository {
  static async createCardProgram(request: CreateCardProgramRequest) {
    return client
      .post<CreateCardProgramRequest, CardProgram>('/simulate/cards/programs', request)
      .then((response) => convertValues<CardProgram>(response));
  }

  static async receiveACHCredit(request: AchReceiveACHTransferRequest) {
    return client
      .post<AchReceiveACHTransferRequest, AchReceiveACHTransferResponse>('/simulate/receive-ach-credit', request)
      .then((response) => convertValues<AchReceiveACHTransferResponse>(response));
  }

  static async receiveACHDebit(request: AchReceiveACHTransferRequest) {
    return client
      .post<AchReceiveACHTransferRequest, AchReceiveACHTransferResponse>('/simulate/receive-ach-debit', request)
      .then((response) => convertValues<AchReceiveACHTransferResponse>(response));
  }

  static async settleACH(request: AchSettleACHTransferRequest) {
    return client
      .post<AchSettleACHTransferRequest, AchSettleACHTransferResponse>('/simulate/transfers/ach/settle', request)
      .then((response) => convertValues<AchSettleACHTransferResponse>(response));
  }

  static async receiveWire(request: WireReceiveWireTransferRequest) {
    return client
      .post<WireReceiveWireTransferRequest, WireReceiveWireTransferResponse>('/simulate/receive-wire', request)
      .then((response) => convertValues<WireReceiveWireTransferResponse>(response));
  }

  static async settleWire(request: WireSettleWireTransferRequest) {
    return client
      .post<WireSettleWireTransferRequest, WireSettleWireTransferResponse>('/simulate/transfers/wire/settle', request)
      .then((response) => convertValues<WireSettleWireTransferResponse>(response));
  }

  static async receiveInternationalWire(request: WireReceiveWireTransferRequest) {
    return client
      .post<
        WireReceiveWireTransferRequest,
        WireReceiveWireTransferResponse
      >('/simulate/receive-international-wire', request)
      .then((response) => convertValues<WireReceiveWireTransferResponse>(response));
  }

  static async createRealtimeTransfer(request: RealtimeReceiveTransferRequest) {
    return client
      .post<RealtimeReceiveTransferRequest, RealtimeTransfer>('/simulate/transfers/realtime/receive-credit', request)
      .then((response) => convertValues<RealtimeTransfer>(response));
  }
}
